import Vue from 'vue'

/**
 * 新增夏令时配置
 * @param params
 * @returns {*}
 */
export const timezoneSync = params => {
  return Vue.fetch.post('/apiv1/device/dstConfig/timezoneSync', params)
}

/**
 * 新增夏令时配置
 * @param params
 * @returns {*}
 */
export const addDstConfig = params => {
  return Vue.fetch.post('/apiv1/device/dstConfig/add', params)
}

/**
 * 修改夏令时配置
 * @returns {*}
 */
export const updateDstConfig = params => {
  return Vue.fetch.post('/apiv1/device/dstConfig/update', params)
}

/**
 * 夏令时配置分页列表
 * @returns {*}
 */
export const pageList = params => {
  return Vue.fetch.post('/apiv1/device/dstConfig/pageList', params)
}

/**
 * 删除夏令时配置
 * @returns {*}
 */
export const deleteDstConfig = params => {
  return Vue.fetch.post('/apiv1/device/dstConfig/delete', params)
}

// *******************************************************************

/**
 * 新增设备夏令时关联关系
 * @param params
 * @returns {*}
 */
export const addDevDstLink = params => {
  return Vue.fetch.post('/apiv1/device/devDstLink/add', params)
}

/**
 * 更新设备夏令时关联关系
 * @param params
 * @returns {*}
 */
export const updateDevDstLink = params => {
  console.log(params)
  // return Vue.fetch.post('/apiv1/device/devDstLink/update', params)
}

/**
 * 删除设备夏令时关联关系
 * @param params
 * @returns {*}
 */
export const deleteDevDstLink = params => {
  return Vue.fetch.post('/apiv1/device/devDstLink/delete', params)
}

// **************************************************
export const addTimeZone = params => {
  return Vue.fetch.post('/apiv1/device/dstConfig/addTimeZone', params)
}



// WEBPACK FOOTER //
// ./src/services/dstConfigApi.js